import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from 'rp-react-svg-icon';
import { statisticsUrl } from '../../helpers/urlBuilder';

/**
 * Cell contains link to sales detailed statistic
 *
 * @param {{}} props
 * @constructor
 */
const StatisticsLinkCell = props => (
    <a
        href={statisticsUrl(
            props.rowData[props.customCell.options.columnUid],
            props.rowData[props.customCell.options.columnDate]
        )}
        className={
            classNames(
                'ui-link ui-link_table',
                { 'ui-link_marked': props.rowData[props.customCell.options.columnPast] }
            )
        }
    >
        <span>
            {props.rowData[props.columnName]}
        </span>
        <span>
            {'\uFEFF'}
            <Svg
                iconName="right"
                size="XSmall"
            />
        </span>
    </a>
);

StatisticsLinkCell.propTypes = {
    /**
     * Single row data
     */
    rowData: PropTypes.object.isRequired,
    /**
     * Name of current column
     */
    columnName: PropTypes.string.isRequired,
    /**
     * Custom cell component and options
     */
    customCell: PropTypes.object.isRequired
};

export default StatisticsLinkCell;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/StatisticsLinkCell.js